import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { organizationAutoCompleteInput$, organizationAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const OrganizationAutoSuggest = renderAutoSuggestWithOptions(
   organizationAutoCompleteObservable$,
   organizationAutoCompleteInput$,
);

OrganizationAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Organization...',
};

export default OrganizationAutoSuggest;
